var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BlBackdrop",
    { attrs: { title: "Cancel appointment", footer: false } },
    [
      _c(
        "div",
        {
          staticClass: "overflow-y-auto px-8 mb-4",
          style: { width: "40rem", maxHeight: "calc(100vh - 14rem)" }
        },
        [
          _vm.modalLoading
            ? _c("div", { staticClass: "h-64 grid place-items-center" }, [
                _c("div", { staticClass: "blum-loader" })
              ])
            : _vm.appointment && _vm.praCancelOpened
            ? _c("div", [
                _vm.appointment.client
                  ? _c(
                      "div",
                      { staticClass: "mb-4" },
                      [
                        _c("BlTextBody2", {
                          attrs: { text: "This appointment for" }
                        }),
                        _vm._v(" "),
                        _c("BlTextBody2", {
                          staticClass: "font-bold",
                          attrs: { text: _vm.appointment.client.name }
                        }),
                        _vm._v(" "),
                        _c("BlTextBody2", {
                          attrs: {
                            text:
                              "is part of the recurring appointment. Would you like to cancel just this one, or this and all following appointments (totaling"
                          }
                        }),
                        _vm._v(" "),
                        _c("BlTextBody2", {
                          staticClass: "font-bold",
                          attrs: {
                            text: _vm.totalCancellation + " appointments)?"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "grid grid-cols-2 gap-2" },
                  _vm._l(_vm.cancelOptionOptions, function(opt) {
                    return _c(
                      "div",
                      {
                        key: opt.value,
                        staticClass:
                          "h-22 flex items-center justify-center text-center rounded border cursor-pointer",
                        class: {
                          "border-light-purple":
                            _vm.cancelOptionInput === opt.value
                        },
                        on: {
                          click: function($event) {
                            _vm.cancelOptionInput = opt.value
                          }
                        }
                      },
                      [
                        _c("BlTextSubtitle3", {
                          class: [
                            _vm.cancelOptionInput === opt.value
                              ? "text-light-purple"
                              : "text-slate-700"
                          ],
                          attrs: { text: opt.label }
                        })
                      ],
                      1
                    )
                  }),
                  0
                )
              ])
            : _vm.appointment && !_vm.praCancelOpened
            ? _c("div", [
                _vm.appointment.client
                  ? _c("div", { staticClass: "mb-4" }, [
                      _vm.cancelOptionInput === "current"
                        ? _c(
                            "div",
                            [
                              _c("BlTextBody2", {
                                attrs: {
                                  text:
                                    "You are about to cancel the appointment for"
                                }
                              }),
                              _vm._v(" "),
                              _c("BlTextBody2", {
                                staticClass: "font-bold",
                                attrs: { text: _vm.appointment.client.name }
                              }),
                              _vm._v(" "),
                              _c("BlTextBody2", {
                                attrs: { text: "with the following details:" }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.cancelOptionInput === "current_and_following"
                        ? _c(
                            "div",
                            [
                              _c("BlTextBody2", {
                                attrs: {
                                  text: "To proceed with the cancellation for"
                                }
                              }),
                              _vm._v(" "),
                              _c("BlTextBody2", {
                                staticClass: "font-bold",
                                attrs: {
                                  text: _vm.appointment.client.name + ","
                                }
                              }),
                              _vm._v(" "),
                              _c("BlTextBody2", {
                                attrs: {
                                  text:
                                    "please provide the cancellation details. These will apply to all"
                                }
                              }),
                              _vm._v(" "),
                              _c("BlTextBody2", {
                                attrs: { text: _vm.totalCancellation }
                              }),
                              _vm._v(" "),
                              _c("BlTextBody2", {
                                attrs: { text: "appointments." }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.cancelOptionInput === "current"
                  ? _c("div", { staticClass: "flex items-center gap-2 mb-4" }, [
                      _c(
                        "div",
                        { staticClass: "w-25 flex-shrink-0 rounded shadow-md" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "h-7 flex items-center justify-center rounded-t bg-orange-200"
                            },
                            [
                              _c("BlTextBody2", {
                                staticClass: "text-orange-700",
                                attrs: { text: "Existing" }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "h-18 flex flex-col items-center justify-center rounded-b bg-pure-white"
                            },
                            [
                              _c("BlTextTitle4", {
                                staticClass: "text-orange-700",
                                attrs: {
                                  text: _vm.displayDate({
                                    date: _vm.appointment.date,
                                    format: "DD"
                                  })
                                }
                              }),
                              _vm._v(" "),
                              _c("BlTextBody2", {
                                staticClass: "text-orange-600",
                                attrs: {
                                  text: _vm.displayDate({
                                    date: _vm.appointment.date,
                                    format: "MMMM"
                                  })
                                }
                              })
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "flex flex-col gap-1 px-2" }, [
                        _c(
                          "div",
                          {
                            staticClass: "max-w-100 flex items-center gap-2",
                            attrs: {
                              text:
                                (_vm.appointment.user &&
                                  _vm.appointment.user.name) ||
                                "No therapist assigned"
                            }
                          },
                          [
                            _c("BlIcon", {
                              staticClass: "h-4 w-4",
                              attrs: { icon: "user", color: "slate-6" }
                            }),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              staticClass: "truncate",
                              attrs: {
                                text:
                                  (_vm.appointment.user &&
                                    _vm.appointment.user.name) ||
                                  "No therapist assigned"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "flex items-center gap-2" },
                          [
                            _c("BlIcon", {
                              staticClass: "h-4 w-4",
                              attrs: { icon: "clock-outline", color: "slate-6" }
                            }),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              attrs: {
                                text:
                                  _vm.appointment.start_time_string +
                                  " - " +
                                  _vm.appointment.end_time_string
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.enableBranch
                          ? _c(
                              "div",
                              {
                                staticClass: "max-w-100 flex items-center gap-2"
                              },
                              [
                                _c("BlIcon", {
                                  staticClass: "h-4 w-4",
                                  attrs: { icon: "location", color: "slate-6" }
                                }),
                                _vm._v(" "),
                                _c("BlTextBody2", {
                                  staticClass: "truncate",
                                  attrs: {
                                    text: _vm.appointment.room.branch
                                      ? _vm.appointment.room.branch.name
                                      : "No branch"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "max-w-100 flex items-center gap-2" },
                          [
                            _c("BlIcon", {
                              staticClass: "h-4 w-4",
                              attrs: { icon: "door", color: "slate-6" }
                            }),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              staticClass: "truncate",
                              attrs: { text: _vm.appointment.room.name }
                            })
                          ],
                          1
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.cancelOptionInput === "current_and_following"
                  ? _c("div", { staticClass: "flex items-center gap-2 mb-4" }, [
                      _c(
                        "div",
                        { staticClass: "w-25 flex-shrink-0 rounded shadow-md" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "h-7 flex items-center justify-center rounded-t bg-orange-200"
                            },
                            [
                              _c("BlTextBody2", {
                                staticClass: "text-orange-700",
                                attrs: { text: "Start" }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "h-18 flex flex-col items-center justify-center rounded-b bg-pure-white"
                            },
                            [
                              _c("BlTextTitle4", {
                                staticClass: "text-orange-700",
                                attrs: {
                                  text: _vm.displayDate({
                                    date: _vm.appointment.date,
                                    format: "DD"
                                  })
                                }
                              }),
                              _vm._v(" "),
                              _c("BlTextBody2", {
                                staticClass: "text-orange-600",
                                attrs: {
                                  text: _vm.displayDate({
                                    date: _vm.appointment.date,
                                    format: "MMMM"
                                  })
                                }
                              })
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex flex-col items-center justify-center w-full"
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "flex items-center gap-2" },
                            [
                              _c("BlTextBody2", {
                                attrs: {
                                  text: _vm.totalCancellation + " appointments"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "flex items-center gap-3" },
                            [
                              _c("div", {
                                staticClass:
                                  "h-3 w-3 flex-shrink-0 rounded-full bg-slate-500"
                              }),
                              _vm._v(" "),
                              _vm._l(13, function(n) {
                                return _c("div", {
                                  key: n,
                                  staticClass:
                                    "h-0.5 w-3 flex-shrink-0 bg-slate-500"
                                })
                              }),
                              _vm._v(" "),
                              _c("div", {
                                staticClass:
                                  "h-3 w-3 flex-shrink-0 rounded-full bg-slate-500"
                              })
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "h-5.5 flex-shrink-0" })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "w-25 flex-shrink-0 rounded shadow-md" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "h-7 flex items-center justify-center rounded-t bg-orange-200"
                            },
                            [
                              _c("BlTextBody2", {
                                staticClass: "text-orange-700",
                                attrs: { text: "End" }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "h-18 flex flex-col items-center justify-center rounded-b bg-pure-white"
                            },
                            [
                              _c("BlTextTitle4", {
                                staticClass: "text-orange-700",
                                attrs: {
                                  text: _vm.displayDate({
                                    date:
                                      _vm.appointment
                                        .last_upcoming_appointment_date,
                                    format: "DD"
                                  })
                                }
                              }),
                              _vm._v(" "),
                              _c("BlTextBody2", {
                                staticClass: "text-orange-600",
                                attrs: {
                                  text: _vm.displayDate({
                                    date:
                                      _vm.appointment
                                        .last_upcoming_appointment_date,
                                    format: "MMMM"
                                  })
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "mb-4 flex flex-col gap-4" }, [
                  _c("div", { staticClass: "flex flex-col gap-1" }, [
                    _c(
                      "label",
                      [
                        _c("BlTextBody2", {
                          attrs: {
                            text: "Select who is requesting the cancellation:"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "grid grid-cols-3 gap-2" },
                      _vm._l(_vm.cancellationRequesterTypeOptions, function(
                        item
                      ) {
                        return _c(
                          "div",
                          {
                            key: item.value,
                            staticClass:
                              "h-15 flex items-center justify-center text-center rounded border cursor-pointer",
                            class: {
                              "border-light-purple":
                                _vm.cancellationRequesterTypeInput ===
                                item.value
                            },
                            on: {
                              click: function($event) {
                                _vm.cancellationRequesterTypeInput = item.value
                              }
                            }
                          },
                          [
                            _c("BlTextSubtitle3", {
                              class: [
                                _vm.cancellationRequesterTypeInput ===
                                item.value
                                  ? "text-light-purple"
                                  : "text-slate-700"
                              ],
                              attrs: { text: item.label }
                            })
                          ],
                          1
                        )
                      }),
                      0
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex flex-col gap-1" }, [
                    _c(
                      "label",
                      [
                        _c("BlTextBody2", {
                          attrs: {
                            text:
                              "Do you want to apply a deduction of " +
                              _vm.currentSlotCount +
                              " credit(s) for this cancellation?"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "grid grid-cols-2 gap-2" },
                      _vm._l(_vm.subtractSessionCreditOptions, function(item) {
                        return _c(
                          "div",
                          {
                            key: item.value,
                            staticClass:
                              "h-15 flex items-center justify-center text-center rounded border cursor-pointer",
                            class: {
                              "border-light-purple":
                                _vm.subtractSessionCreditInput === item.value
                            },
                            on: {
                              click: function($event) {
                                _vm.subtractSessionCreditInput = item.value
                              }
                            }
                          },
                          [
                            _c("BlTextSubtitle3", {
                              class: [
                                _vm.subtractSessionCreditInput === item.value
                                  ? "text-light-purple"
                                  : "text-slate-700"
                              ],
                              attrs: { text: item.label }
                            })
                          ],
                          1
                        )
                      }),
                      0
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "flex flex-col gap-1" },
                    [
                      _c("BlSelectBox", {
                        attrs: {
                          label: "Please select reason for the cancellation.",
                          asterisk: "",
                          placeholder: "Select cancellation reason",
                          options: _vm.centerReasonSettings.map(function(i) {
                            return {
                              value: i.formatted_name,
                              label: i.name
                            }
                          }),
                          drop: "up"
                        },
                        on: {
                          change: function($event) {
                            _vm.cancellationReasonInput = $event
                          }
                        },
                        model: {
                          value: _vm.cancellationReasonInput,
                          callback: function($$v) {
                            _vm.cancellationReasonInput = $$v
                          },
                          expression: "cancellationReasonInput"
                        }
                      }),
                      _vm._v(" "),
                      _vm.cancellationReasonInput === _vm.defaultReason
                        ? _c("BlInputText", {
                            attrs: { input: _vm.otherCancellationReasonInput },
                            on: { changed: _vm.inputHandler }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ])
              ])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex items-center justify-end gap-4 px-8 pb-8" },
        [
          _vm.praCancelOpened || _vm.totalCancellation === 1
            ? _c("BlInputButton", {
                attrs: { type: "plain", label: "Cancel" },
                on: {
                  clicked: function($event) {
                    return _vm.$emit("close-modal")
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.praCancelOpened && _vm.totalCancellation > 1
            ? _c("BlInputButton", {
                attrs: { type: "plain", label: "Back" },
                on: {
                  clicked: function($event) {
                    _vm.praCancelOpened = true
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.modalLoading
            ? _c(
                "div",
                [
                  _vm.praCancelOpened
                    ? _c("BlInputButton", {
                        attrs: { label: "Next", loading: _vm.submitLoading },
                        on: { clicked: _vm.onNext }
                      })
                    : _c("BlInputButton", {
                        attrs: {
                          label: "Confirm cancellation",
                          disabled: _vm.disabledSubmit,
                          loading: _vm.submitLoading
                        },
                        on: { clicked: _vm.onCancelAppointment }
                      })
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c8bbe076", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c8bbe076","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/appointments/modal/CancelAppointmentModal.vue
// module id = null
// module chunks = 